// SCSS imports
// --------------------------------------------------------
import '../scss/index.scss';

// JS imports
// --------------------------------------------------------
import { header, hero, heroHeight, mobileMenuState, progressBar, scrollTopBtn } from './variables';
import {
  changeCommentsColorOnToggle,
  changeTwitterCardTheme,
  switchTheme,
} from './modules/darkMode';
import { initHeader } from './modules/header';
import { initHeroSlider } from './modules/initSlider';
import { loadMore } from './modules/loadMore';
import { copyToClipboard } from './modules/copyToClipboard';
import { initProgressBar } from './modules/progressBar';
import { togglePlan } from './modules/membershipToggle';
import { calcHeight } from './modules/membershipCards';
import { initHero } from './modules/heroSection';
import { initMobileMenu } from './modules/mobileMenu';
import { initScrollTop } from './modules/scrollToTopBtn';

// Header And Mobile Menu Script
// --------------------------------------------------------

if (!!header) {
  initHeader();
  initMobileMenu(header, mobileMenuState);
  // window.addEventListener('resize', () => {
  //   initHeader();
  // });
}

// Hero Section/Post Hero (Head) Section Script
// --------------------------------------------------------

if (!!hero) {
  initHero();
  // window.addEventListener('resize', () => initHero());
}

// Progress Bar Script
// --------------------------------------------------------

if (!!progressBar) {
  initProgressBar(progressBar, mobileMenuState, heroHeight);
}

// Dark Mode Script
// --------------------------------------------------------
const switchThemeBtns = document.querySelectorAll('.switch-theme-btn');

if (switchThemeBtns) {
  switchThemeBtns.forEach((switchThemeBtn) => {
    switchThemeBtn.addEventListener('click', switchTheme);
  });
}

window.addEventListener('load', changeTwitterCardTheme);
window.addEventListener('load', changeCommentsColorOnToggle);

// Slider Script
// --------------------------------------------------------

initHeroSlider();

// Load More button script
// --------------------------------------------------------

loadMore();

// Copy to clipboard button script
// --------------------------------------------------------

copyToClipboard();

// Function that toggles yearly/monthly plan on membership page
// --------------------------------------------------------

togglePlan();

// Function that calculates height of the tier cards description on the membership page so descriptions height is the same
// --------------------------------------------------------

calcHeight();

// Scroll To Top Button Script
// --------------------------------------------------------

initScrollTop(scrollTopBtn);
